/* eslint-disable react-hooks/exhaustive-deps */
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import {
  CartItemTypes,
  IAttachment,
} from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import {
  AttachmentTypes,
  IConsultDetails,
} from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import CommonFormBuilder from "@/app/components/common-form-builder/CommonFormBuilder";
import { useUploadFiles } from "@/app/components/common-form-builder/common-fields/hook-upload-files/hook-multiple-files/useUploadFiles";
import ToastForUpload from "@/app/components/common-form-builder/common-fields/hook-upload-files/upload-files-helpers/ToastForUpload";
import {
  adaptFieldsToPost,
  defaultValues,
  renameFields,
} from "@/app/components/common-form-builder/form-builder-helpers/form-functions";
import Separator from "@/app/components/lib/Separator";
import { IReply } from "@/app/components/pages-components/user-pages/consultations-page/consultations-details/ConsultationsDetails";
import { useTranslation } from "@/hooks/localization/useTranslations";
import {
  IConsultCart_extraFields,
  IuseProductHasAttrsResult,
} from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ConsltAttachments from "./consult-form-helpers/ConsltAttachments";
import ConsultRecordedFiles from "./consult-form-helpers/ConsultRecordedFiles";
import ConsultSubmitSection from "./consult-form-helpers/ConsultSubmitSection";
import ConsultationMessage from "./consult-form-helpers/ConsultationMessage";
import UploadFiles from "./consult-form-helpers/UploadFiles";

interface Props {
  productState?: IuseProductHasAttrsResult;
  product?: IConsultDetails | null;
  isDetails?: boolean;
  reply?: IReply;
}
const ConsultationForm: React.FC<Props> = ({
  productState,
  product,
  isDetails = false,
  reply = null,
}) => {
  const mobile = useIsMobile();
  const t = useTranslation();
  const { filesUrls, msgErr, setMsgErr, handleUpload, handleRemove } =
    useUploadFiles();
  const [audioUrls, setAudioUrls] = useState<string[]>([]);

  const hookForm = useForm();

  const { currentProd, otherInputs } = productState ?? {};
  const [fields, setFields] = useState<Array<IField>>([]);
  const fieldsBuilder = product?.fields_builder;
  useEffect(() => {
    if (!productState || !product) return;
    const getKey = (str: string) => {
      const string = str.split(".");
      return string[string.length - 1];
    };
    const initFields = new Array<IField>();
    fieldsBuilder?.forEach((field) => {
      initFields?.push({
        ...field,
        value: otherInputs?.[getKey(field?.configurations?.key)],
      });
    });
    const fields = renameFields(initFields);
    hookForm.reset(defaultValues(fields));
    setFields(fields!);
  }, [otherInputs, currentProd]);

  const attachFiles =
    currentProd?.custom_data.allowed_attachment?.includes(
      AttachmentTypes.files,
    ) || reply?.allowedAttachment;
  const attachVoices =
    currentProd?.custom_data.allowed_attachment?.includes(
      AttachmentTypes.voices,
    ) || reply?.allowedVoice;

  const submitSection = () => (
    <ConsultSubmitSection
      isDetails={isDetails}
      productState={productState!}
      reply={reply!}
    />
  );

  const handleSubmit = (data: any) => {
    const other_inputs = adaptFieldsToPost(data)?.other_inputs ?? {};
    const urls1: IAttachment[] = attachVoices
      ? audioUrls.map((url, index) => ({
          type: "voice",
          name: `audio${index + 1}`,
          url: url,
        }))
      : [];
    const urls2: IAttachment[] = attachFiles
      ? filesUrls.map((file) => ({
          type: "file",
          name: file.name,
          url: file.url,
        }))
      : [];
    if (reply) {
      const dataToSubmit = {
        content: data.message,
        files: [...urls1, ...urls2],
      };
      reply.handleSabmitReply(dataToSubmit);
    } else {
      const dataToSubmit: IConsultCart_extraFields = {
        type: CartItemTypes.consultation,
        message: data.message,
        files: [...urls1, ...urls2],
      };
      productState?.handleAddToCart(dataToSubmit, {
        other_inputs,
      });
    }
  };

  const mForm = reply ? "my-consult-form" : "";
  return (
    <>
      {msgErr.length > 0 && (
        <ToastForUpload
          message={msgErr}
          show={msgErr.length > 0}
          setShow={() => setMsgErr([])}
        />
      )}
      <form onSubmit={hookForm.handleSubmit(handleSubmit)}>
        <div style={{ marginBottom: 24 }}>
          {fieldsBuilder &&
            fields?.length > 0 &&
            fields?.map((field) => (
              <div key={field?.configurations?.key}>
                <Separator
                  marginBottom={8}
                  startLabel={field?.configurations?.title}
                />
                <CommonFormBuilder field={field} form={hookForm} />
              </div>
            ))}
        </div>

        <div className="consult-section">
          {!reply ? (
            isDetails ? (
              <Separator startLabel={t.your_message} marginBottom={8} />
            ) : (
              <div className="consult-section-title">{t.your_message}</div>
            )
          ) : (
            <></>
          )}
          <div className={"consult-form " + mForm}>
            <ConsultationMessage
              form={hookForm}
              required={true}
              placeholder={reply?.placeHolder}
            />
            <div className="consult-attach-submit">
              {(attachFiles || attachVoices) && (
                <>
                  <ConsltAttachments
                    filesUrls={attachFiles ? filesUrls : []}
                    handleRemoveFile={handleRemove}
                    audioUrls={attachVoices ? audioUrls : []}
                    setAudioUrls={setAudioUrls}
                  />
                  <div className="consult-attach-btns">
                    {attachFiles && (
                      <UploadFiles
                        caption={mobile ? "" : t.attach_files}
                        handleUpload={handleUpload}
                      />
                    )}
                    {attachVoices && (
                      <ConsultRecordedFiles
                        addToRecordList={(url) =>
                          setAudioUrls([...audioUrls, url])
                        }
                      />
                    )}
                  </div>
                </>
              )}
              {!isDetails && submitSection()}
            </div>
          </div>
          {isDetails && submitSection()}
        </div>
      </form>
    </>
  );
};

export default ConsultationForm;
